(() => {
  const SELECTOR = '[data-mbb-how-it-works-steps]';

  class MbbHowItWorksSteps {
    constructor(section) {
      if (!section || section.dataset.mbbStepsInitialized === 'true') return;

      this.section = section;
      this.items = [...section.querySelectorAll('[data-mbb-step-reveal]')];
      this.reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      this.init();
    }

    init() {
      this.section.dataset.mbbStepsInitialized = 'true';

      if (this.reducedMotion || !('IntersectionObserver' in window)) {
        this.reveal();
        return;
      }

      this.observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            this.reveal();
            this.observer.disconnect();
          });
        },
        {
          threshold: 0.18,
          rootMargin: '0px 0px -8% 0px'
        }
      );

      this.observer.observe(this.section);
    }

    reveal() {
      this.section.classList.add('is-visible');

      this.items.forEach(item => {
        item.classList.add('is-visible');
      });
    }

    destroy() {
      this.observer?.disconnect();

      this.section.classList.remove('is-visible');
      this.items.forEach(item => item.classList.remove('is-visible'));

      delete this.section.dataset.mbbStepsInitialized;
    }
  }

  const init = root => {
    const sections = root.matches?.(SELECTOR)
      ? [root]
      : root.querySelectorAll?.(SELECTOR) || [];

    sections.forEach(section => {
      if (section.dataset.mbbStepsInitialized === 'true') return;

      section.mbbHowItWorksSteps = new MbbHowItWorksSteps(section);
    });
  };

  const start = () => init(document);

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start, { once: true })
    : start();

  document.addEventListener('shopify:section:load', event => {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', event => {
    const section = event.target.matches?.(SELECTOR)
      ? event.target
      : event.target.querySelector?.(SELECTOR);

    section?.mbbHowItWorksSteps?.destroy();
  });
})();